var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportSchedulingMin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35126 11.4678V20.5H2.96454V11.4678H6.35126ZM10.8679 20.5H7.48114V9.20996H10.8679V20.5ZM15.3835 20.5H11.9968V6.95117H15.3835V20.5ZM21.0856 5.82227H19.9567V20.5H16.569V5.82227H15.4401L18.2634 3L21.0856 5.82227Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35126 11.4678V20.5H2.96454V11.4678H6.35126ZM10.8679 20.5H7.48114V9.20996H10.8679V20.5ZM15.3835 20.5H11.9968V6.95117H15.3835V20.5ZM21.0856 5.82227H19.9567V20.5H16.569V5.82227H15.4401L18.2634 3L21.0856 5.82227Z",
    fill: "black",
    fillOpacity: 0.65
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportSchedulingMin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Report-Scheduling-min.75104e89014c7c9830bf65082babbf78.svg";